export default __webpack_public_path__ + "static/media/a.b30430c737e82f4decd016ba82eb07a0.mp3";